import { render, staticRenderFns } from "./ChatDashboard.vue?vue&type=template&id=c4f2bfac&scoped=true&"
import script from "./ChatDashboard.vue?vue&type=script&lang=js&"
export * from "./ChatDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ChatDashboard.vue?vue&type=style&index=0&id=c4f2bfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2bfac",
  null
  
)

export default component.exports